import SectionHeader from "../SectionHeader";
import MilestoneTracker from "../MilestoneTracker";
import BudgetSummary from "../BudgetSummary";
import Skeleton from "Components/Common/Skeleton/Skeleton";

interface BudgetRow {
  label: string;
  value: string;
  isTotal?: boolean;
  variant?: string;
  size?: string;
}

interface BudgetProgress {
  timeClass: string;
  timeValue: string;
  workClass: string;
  workValue: string;
}

interface Milestone {
  label: string;
  state: string;
  icon?: string;
}

interface BudgetSectionProps {
  isActive: boolean;
  milestones: Milestone[];
  contractRows: BudgetRow[];
  scheduleRows: BudgetRow[];
  scheduleNote?: string;
  progress?: BudgetProgress;
  loading?: boolean;
}

const BudgetSection = ({
  isActive,
  milestones,
  contractRows,
  scheduleRows,
  scheduleNote,
  progress,
  loading = false,
}: BudgetSectionProps) => {
  return (
    <div className={`section ${isActive ? "active" : ""}`} id="sec-budget">
      <SectionHeader
        title="Schedule & Budget"
        subtitle="Contract value, draw history, change orders, and project milestone tracker."
      />

      <MilestoneTracker milestones={milestones} progressClass="w50" />

      {loading ? (
        <div className="twoCol">
          <div className="card">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton
                key={i}
                height={32}
                borderRadius={6}
                style={{ marginBottom: 8 }}
              />
            ))}
          </div>
          <div className="card">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton
                key={i}
                height={32}
                borderRadius={6}
                style={{ marginBottom: 8 }}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="twoCol">
          <BudgetSummary
            title="Contract & Budget Summary"
            rows={contractRows}
          />
          <BudgetSummary
            title="Schedule Summary"
            rows={scheduleRows}
            note={scheduleNote}
            noteClass="noteAmber"
            progress={progress}
          />
        </div>
      )}
    </div>
  );
};

export default BudgetSection;
